export class VehiculeInfo {
  public idVehicule: number;
  public matricule: string;
  public mark: string;
  public alias: string;
  public device: DeviceLabel;
  public lastName: string;
  public idDriver: number;
  public telephone: string;
  public maxSpeed: number;
  public emails: string = "";
  constructor() {}

}
export class DeviceLabel {
  public idDevice: number;
  public deviceNumber: number;
  constructor(idDevice: number, deviceNumber: number) {
    this.idDevice = idDevice;
    this.deviceNumber = deviceNumber;
  }
}


export class GroupLabel {
  public idGroupe: number;
  public nom: String
  constructor(idGroupe: number, nom: String) {
    this.idGroupe = idGroupe;
    this.nom = nom;
  }

}

export class CustomSelectInfo {
  public text: String;
  public id: number;

  constructor(text: String, id: number) {
    this.text = text;
    this.id = id;
  }

}

export class Vehicule {
  public idVehicule: number;
  public matricule: string;
  public mark: string;
  public alias: string;
  public maxSpeed: number;
  public emails: string;
  constructor() {}
}



// WEBPACK FOOTER //
// ./src/objects/vehicule.ts